import { lazy, Suspense } from 'react'
import { Navigate, Route, Routes, useLocation } from 'react-router-dom'
import { BottomNav, DesktopRail } from './components'

const HomePage = lazy(() => import('./pages').then((module) => ({ default: module.HomePage })))
const PulsePage = lazy(() => import('./pages').then((module) => ({ default: module.PulsePage })))
const CreatePage = lazy(() => import('./pages').then((module) => ({ default: module.CreatePage })))
const EditorPage = lazy(() => import('./pages').then((module) => ({ default: module.EditorPage })))
const LoopDetailPage = lazy(() => import('./pages').then((module) => ({ default: module.LoopDetailPage })))
const ProfilePage = lazy(() => import('./pages').then((module) => ({ default: module.ProfilePage })))
const ScenePage = lazy(() => import('./pages').then((module) => ({ default: module.ScenePage })))
const EchoPage = lazy(() => import('./pages').then((module) => ({ default: module.EchoPage })))
const ChainPage = lazy(() => import('./pages').then((module) => ({ default: module.ChainPage })))
const LineagePage = lazy(() => import('./pages').then((module) => ({ default: module.LineagePage })))
const ActivityPage = lazy(() => import('./pages').then((module) => ({ default: module.ActivityPage })))
const SettingsPage = lazy(() => import('./pages').then((module) => ({ default: module.SettingsPage })))
const PitchPage = lazy(() => import('./pages').then((module) => ({ default: module.PitchPage })))
const ModerationPage = lazy(() => import('./pages').then((module) => ({ default: module.ModerationPage })))
const PlatformPreviewPage = lazy(() => import('./pages').then((module) => ({ default: module.PlatformPreviewPage })))
const CreatorValuePage = lazy(() => import('./pages').then((module) => ({ default: module.CreatorValuePage })))
const AuthPage = lazy(() => import('./pages').then((module) => ({ default: module.AuthPage })))

function Loading() { return <div className="route-loading"><i /><span>SPLICING SIX SECONDS</span></div> }

export default function App() {
  const location = useLocation()
  const immersive = location.pathname === '/' || location.pathname.startsWith('/editor/') || location.pathname.startsWith('/loop/')
  const noNav = location.pathname.startsWith('/editor/') || location.pathname === '/pitch' || location.pathname === '/platform-preview'
  return <div className={`app ${immersive ? 'app--immersive' : ''}`}>
    {!noNav && <DesktopRail />}
    <main id="main-content"><Suspense fallback={<Loading />}><Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/pulse" element={<PulsePage />} />
      <Route path="/create" element={<CreatePage />} />
      <Route path="/editor/:draftId" element={<EditorPage />} />
      <Route path="/loop/:id" element={<LoopDetailPage />} />
      <Route path="/profile/:handle" element={<ProfilePage />} />
      <Route path="/scene/:slug" element={<ScenePage />} />
      <Route path="/echo/:id" element={<EchoPage />} />
      <Route path="/chain/:id" element={<ChainPage />} />
      <Route path="/lineage/:id" element={<LineagePage />} />
      <Route path="/activity" element={<ActivityPage />} />
      <Route path="/settings" element={<SettingsPage />} />
      <Route path="/pitch" element={<PitchPage />} />
      <Route path="/admin/moderation" element={<ModerationPage />} />
      <Route path="/platform-preview" element={<PlatformPreviewPage />} />
      <Route path="/creator-value" element={<CreatorValuePage />} />
      <Route path="/auth" element={<AuthPage />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes></Suspense></main>
    {!noNav && <BottomNav />}
  </div>
}
